import { render, staticRenderFns } from "./UserCreate.vue?vue&type=template&id=2f212c19&scoped=true"
import script from "./UserCreate.vue?vue&type=script&lang=js"
export * from "./UserCreate.vue?vue&type=script&lang=js"
import style0 from "./UserCreate.vue?vue&type=style&index=0&id=2f212c19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f212c19",
  null
  
)

export default component.exports